<template>
    <el-select v-model="values" placeholder="请选择" @change="change" style="width: 100%;">
        <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
    name: "PriceTimeSelect",
    data(){
        return{
            list:[
                {name:'天',id:'day'},
                {name:'周',id:'week'},
                {name:'月',id:'month'},
                {name:'年',id:'year'}
            ],
            values:''
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        value:{
            type:[String,Number],
            default:''
        }
    },
    created() {
        this.values = this.value ? this.value : 'month';
    },
    watch:{
        value(n,o){
            this.values = n ? n : '';
        }
    },
    mounted() {
    },
    methods:{
        change(e){
            this.$emit("change", e);
        }
    }
}
</script>
